// ============================================================================
// CONTACT US — public page (/contact)
// Razorpay verifies that a real address, email and phone number are published.
// Static only — no form, no API call, so it renders outside AuthGate.
// ============================================================================

import React from 'react';
import { Mail, Phone, MapPin, Clock, Building2 } from 'lucide-react';
import LegalLayout from './LegalLayout';
import companyInfo from './companyInfo';

const Contact = () => (
  <LegalLayout
    title="Contact Us"
    subtitle="Reach the team behind the platform."
    showEffectiveDate={false}
  >
    <div className="legal__cards">
      <div className="legal__card">
        <div className="legal__card-icon"><Mail size={18} /></div>
        <h3>Email</h3>
        <p><a href={`mailto:${companyInfo.supportEmail}`}>{companyInfo.supportEmail}</a></p>
        <span className="legal__card-note">Billing, support and privacy requests</span>
      </div>

      <div className="legal__card">
        <div className="legal__card-icon"><Phone size={18} /></div>
        <h3>Phone</h3>
        <p><a href={`tel:${companyInfo.supportPhone.replace(/\s/g, '')}`}>{companyInfo.supportPhone}</a></p>
        <span className="legal__card-note">{companyInfo.supportHours}</span>
      </div>

      <div className="legal__card">
        <div className="legal__card-icon"><MapPin size={18} /></div>
        <h3>Registered office</h3>
        <p>
          {companyInfo.address.line1}<br />
          {companyInfo.address.line2}<br />
          {companyInfo.address.city}, {companyInfo.address.state} {companyInfo.address.pincode}<br />
          {companyInfo.address.country}
        </p>
      </div>

      <div className="legal__card">
        <div className="legal__card-icon"><Clock size={18} /></div>
        <h3>Response time</h3>
        <p>Within 1 working day</p>
        <span className="legal__card-note">
          Payment issues are prioritised and usually answered the same day
        </span>
      </div>
    </div>

    <section>
      <h2><Building2 size={18} /> Business details</h2>
      <div className="legal__contact-block">
        <p><strong>Legal name:</strong> {companyInfo.legalName}</p>
        <p><strong>Entity type:</strong> {companyInfo.entityType}</p>
        <p><strong>CIN:</strong> {companyInfo.cin}</p>
        <p><strong>GSTIN:</strong> {companyInfo.gstin}</p>
        <p><strong>Website:</strong> {companyInfo.website}</p>
      </div>
    </section>

    <section>
      <h2>Grievance redressal</h2>
      <p>
        If your issue has not been resolved to your satisfaction, escalate it by email to{' '}
        {companyInfo.supportEmail} with &ldquo;Grievance&rdquo; in the subject line. We
        acknowledge grievances within 48 hours and aim to resolve them within 30 days.
      </p>
      <p className="legal__placeholder">
        [ADD A SEPARATE ESCALATION EMAIL OR OFFICER NAME IF YOU HAVE ONE]
      </p>
    </section>
  </LegalLayout>
);

export default Contact;
